const getLetterBoxName = letterBox => {
  return letterBox.slice(0, letterBox.indexOf('@'));
};

export default getLetterBoxName;
